import { createTheme } from '@mui/material/styles';

// Definiowanie zmiennych kolorów
const colors = {
  dark: '#2d2d2d',
  light: '#f0f0f0',
  // accent: '#D2FA10',
  accent: '#B8B8B0',
  accentDark: '#D98B26',
};

const theme = createTheme({
  typography: {
    fontFamily: '"Raleway", sans-serif', // Ustawienie Raleway jako domyślnej czcionki
    h1: {
      fontFamily: '"Oswald", sans-serif', // Ustawienie Oswald dla nagłówków
      fontSize: 'clamp(1.8rem, 2vw, 2.2rem)',
      lineHeight: 1.1,
    },
    h2: {
      fontFamily: '"Oswald", sans-serif',
      fontSize: 'clamp(1.6rem, 1.8vw, 2rem)',
      lineHeight: 1.15,
    },
    h3: {
      fontFamily: '"Oswald", sans-serif',
      fontSize: 'clamp(1.35rem, 1.5vw, 1.6rem)',
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: '"Oswald", sans-serif',
      fontSize: 'clamp(1.2rem, 1.3vw, 1.4rem)',
      lineHeight: 1.25,
    },
    h5: {
      fontFamily: '"Oswald", sans-serif',
      fontSize: 'clamp(1.05rem, 1.1vw, 1.2rem)',
      lineHeight: 1.3,
    },
    h6: {
      fontFamily: '"Oswald", sans-serif',
      fontSize: 'clamp(1rem, 0.9vw, 1rem)',
      lineHeight: 1.35,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--color-dark': colors.dark,
          '--color-light': colors.light,
          '--color-accent': colors.accent,
          '--color-accent-dark': colors.accentDark,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          margin: '0 0.5rem',
          padding: '0.5rem',
          background: 'none',
          fontWeight: 'bold',
          fontFamily: '"Oswald", sans-serif',
          color: colors.dark,
          position: 'relative',
          overflow: 'hidden', 
          borderRadius: 0,
          fontSize:"1rem",
          '&:hover': {
            background: 'none!important',
          },
          '&:focus': {
            background: 'none',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: 0,
            height: '2px',
            width: '100%',
            backgroundColor: colors.accent,
            transform: 'scaleX(0)',
            transformOrigin: 'bottom right',
            transition: 'transform 0.5s ease', 
          },
          '&:hover::after': {
            transform: 'scaleX(1)',
            transformOrigin: 'bottom left',
          },
          '&:active': {
            backgroundColor: colors.dark,
            boxShadow: '0px 6px 8px rgba(0,0,0,0.3)',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: colors.dark,
      light: colors.light,
      accent: colors.accent,
      accentDark: colors.accentDark,
    },
    secondary: {
      main: colors.accent,
    },
  },
});

export default theme;
